import { Injectable, Inject  } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { IFormVisionHearing } from "../Models/Forms/IFormVisionHearing";
import { BaseService } from './BaseService';

@Injectable()
export class FormVisionHearingService  extends  BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormVisionHearing(id: number) {
    return this._http.get(this._baseUrl + "api/FormVisionHearing/" + id)
      .map((response: IFormVisionHearing) => response as IFormVisionHearing)
      .catch(this.errorHandler);
  }

  insertUpdateFormVisionHearing(formVisionHearingDetails: IFormVisionHearing) {
    return this._http.post(this._baseUrl + 'api/FormVisionHearing', formVisionHearingDetails)
      .map((response: IFormVisionHearing) => response as IFormVisionHearing)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormVisionHearing/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteVisionHearing(id) {
    return this._http.delete(this._baseUrl + "api/FormVisionHearing" + id)
      .map((response: IFormVisionHearing) => response as IFormVisionHearing)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


